import React from "react";
import { Navigation, Pagination, A11y } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/swiper.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "swiper/modules/pagination/pagination.min.css";
import "swiper/modules/a11y/a11y.min.css";
import {formatDateImage} from "../../utils/time";

export function SwiperImg({
  img,
  slidesPerView = 1,
  slidesPerGroup = 1,
  dynamicBullets = false,
  swiperStyle = {},
  imageStyle = { width: "70%" },
}: {
  readonly img: any[];
  readonly slidesPerView?: number;
  readonly slidesPerGroup?: number;
  readonly dynamicBullets?: boolean;
  readonly swiperStyle?: React.CSSProperties;
  readonly imageStyle?: React.CSSProperties;
}) {
  return (
    <Swiper
      style={swiperStyle}
      modules={[Navigation, Pagination, A11y]}
      spaceBetween={50}
      slidesPerView={slidesPerView}
      slidesPerGroup={slidesPerGroup}
      navigation
      pagination={{
        dynamicBullets: dynamicBullets,
        clickable: true,
      }}
    >
      {img?.map((i, index) => (
        <SwiperSlide key={index}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: 'column'
            }}
          >
            <img style={imageStyle} src={i.urlConteudo ?? i} alt="imagem" />
            <p style={{ marginTop:'10px'}}>Data: <strong>{formatDateImage(i.nome)}</strong></p>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
